import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewplanvoicepage',
  templateUrl: './renewplanvoicepage.component.html',
  styleUrls: ['./renewplanvoicepage.component.css']
})
export class RenewplanvoicepageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
